module.exports = __webpack_public_path__ + "312f310924f02637e649661d8744fa58.svg";